import {
  IAdaptationManagementConfig,
  IAdaptationReportSearchParams,
  IFreezedCoveredCallSearchParams,
  IFreezedCoveredCallTableReport,
  ISendManualCMDDTO,
} from "src/Interfaces/collateral";
import {
  getRequest,
  getTable,
  postRequest,
  putRequest,
} from "./requestTemplates";
import { Packet } from "src/Interfaces/commonDtos";
import { ISearchParameters, Report } from "src/Interfaces/TableInterfaces";

const Controller = "/v1/freeze";

export const getAdaptationSetting = (): Promise<IAdaptationManagementConfig> =>
  getRequest(Controller + "/getAdaptationSetting");

export const setAdaptationSetting = (
  config: IAdaptationManagementConfig,
): Promise<Packet<boolean>> =>
  putRequest(Controller + "/setAdaptationSetting", config);

export const setMiddleDayBulkON = (
  accountIds: number[],
): Promise<Packet<boolean>> =>
  putRequest(Controller + "/setMiddleDayBulkOn", accountIds);

export const setMiddleDayBulkOff = (
  accountIds: number[],
): Promise<Packet<boolean>> =>
  putRequest(Controller + "/setMiddleDayBulkOff", accountIds);

export const setCloseDayBulkON = (
  accountIds: number[],
): Promise<Packet<boolean>> =>
  putRequest(Controller + "/setCloseDayBulkOn", accountIds);

export const setCloseDayBulkOff = (
  accountIds: number[],
): Promise<Packet<boolean>> =>
  putRequest(Controller + "/setCloseDayBulkOff", accountIds);

export const getAdaptationUserTable = (
  searchParam: { accountIds: number[] | null },
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<any>> =>
  getTable<{ accountIds: number[] | null }, any>(
    Controller + "/adaptationUser",
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const getAdaptationReportTable = (
  searchParam: IAdaptationReportSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<any>> =>
  getTable<IAdaptationReportSearchParams, any>(
    Controller + "/adaptationReport",
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const getFreezedCoveredCallTable = (
  searchParam: IFreezedCoveredCallSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IFreezedCoveredCallTableReport>> =>
  getTable<IFreezedCoveredCallSearchParams, IFreezedCoveredCallTableReport>(
    Controller + "/getFreezedCoveredCall",
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const getDecreaseCoveredCallTable = (
  searchParam: ISendManualCMDDTO,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<any>> =>
  getTable<ISendManualCMDDTO, any>(
    Controller + "/getDecreaseCoveredCall",
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const getOptimizedAdaptionTable = (
  searchParam: ISendManualCMDDTO,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<any>> =>
  getTable<ISendManualCMDDTO, any>(
    Controller + "/getOptimizedAdaption",
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const getAdaptationLogTable = (
  searchParam: ISendManualCMDDTO,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<any>> =>
  getTable<ISendManualCMDDTO, any>(
    Controller + "/getAdaptationLog",
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const sendManualCMD = (
  dto: ISendManualCMDDTO,
): Promise<Packet<boolean>> =>
  postRequest(Controller + "/getFreezedCoveredCallSendManualCMD", dto);

export const sendOptimizedFreeze = (
  dto: ISendManualCMDDTO,
): Promise<Packet<boolean>> =>
  postRequest(Controller + "/optimizedFreezedInstrument", dto);
